// extracted by mini-css-extract-plugin
export default {"google":"GoogleLogin_google__1pX1G","tooltipAnchor":"GoogleLogin_tooltipAnchor__a9Qge","googleBtn":"GoogleLogin_googleBtn__4p+0u","title":"GoogleLogin_title__xmjJH"};